import React from 'react';
import Portfolio from '../components/Portfolio';

const PortfolioPage = () => {
  return (
    <div className="container">
      <div className="page-section animate-fade-in-up animate-stagger">
        <Portfolio />
      </div>
    </div>
  );
};

export default PortfolioPage;
